/**
 * 我们的歌
 * --------------------------------------------------------------
 * 音频放 public/audio/，封面放 public/photos/
 *
 * ⚠️ 本文件中的 src/cover 路径为占位示例。正式使用前请准备真实文件，
 *    并在对应路径放置音频/封面，否则 SongView 会显示加载错误。
 */

/**
 * @typedef {Object} LyricLine
 * @property {number} time   秒
 * @property {string} text
 *
 * @typedef {Object} Song
 * @property {string} id
 * @property {string} title
 * @property {string} artist
 * @property {string} src
 * @property {string} cover
 * @property {string} story
 * @property {LyricLine[]} lyrics
 */

/** @type {Song[]} */
export const songs = [
  {
    id: 'song-001',
    title: '晚安',
    artist: '夏日入侵企划',
    src: '/audio/song-001.mp3',
    cover: '/photos/song-001-cover.jpg',
    story:
      '我们在一起后的第一首歌。\n\n' +
      '那天深夜你发语音说睡不着，我就把耳机一边塞给自己一边对着手机播这首歌。\n' +
      '副歌那句"晚安"响起的时候你没有回消息——后来才知道，你哭了。',
    lyrics: [
      { time: 0,    text: '（前奏）' },
      { time: 14.0, text: '夜色里的窗台 你靠在我肩膀上' },
      { time: 21.5, text: '说我们要不要 一直走到很远很远' },
      { time: 29.0, text: '我没有回答你 只是牵紧了手' },
      { time: 36.5, text: '像这样沉默的时候 是我最想你的时候' },
      { time: 48.0, text: '（间奏）' },
      { time: 62.0, text: '晚安 是我能说的最温柔的话' },
      { time: 70.0, text: '晚安 是明天醒来你还在' },
      { time: 78.0, text: '晚安 是所有话说完之后' },
      { time: 86.0, text: '我们依然在同一个梦里' },
      { time: 96.0, text: '（尾奏）' },
    ],
  },

  {
    id: 'song-002',
    title: '南山南',
    artist: '马頔',
    src: '/audio/song-002.mp3',
    cover: '/photos/song-002-cover.jpg',
    story:
      '五一去杭州的高铁上一直循环的歌。\n\n' +
      '你靠在我肩膀上睡着，耳机一人一只。\n' +
      '窗外是一路向南的风景。',
    lyrics: [
      { time: 0,    text: '（前奏）' },
      { time: 18.0, text: '你在南方的艳阳里大雪纷飞' },
      { time: 26.0, text: '我在北方的寒夜里四季如春' },
      { time: 34.0, text: '如果天黑之前来得及' },
      { time: 41.0, text: '我要忘了你的眼睛' },
      { time: 50.0, text: '穷极一生做不完一场梦' },
      { time: 62.0, text: '他不再和谁谈论相逢的孤岛' },
      { time: 70.0, text: '因为心里早已荒无人烟' },
    ],
  },
]
